const contracts = [
  // { // Goerli
  //   chainId: 5, 
  //   bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  // }
  // ,
  { // Sepolia
    chainId: 11155111, 
    bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  }
  ,
  { // Holesky
    chainId: 17000, 
    bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  }
  ,
  // { // Mumbai
  //   chainId: 80001, 
  //   bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  // }
  // ,
  { // Amoy
    chainId: 80002, 
    bridge: '0xBE91ac5EAa8B00Fc62ADD0A9F798891A360C4424'
  }
  ,
  { // BNB Testnet
    chainId: 97, 
    bridge: '0x011C427E68593Ee67A14B8936840e7AAF8814405'
  }
  ,
  // { // Arbitrum Goerli Testnet
  //   chainId: 421613, 
  //   bridge: '0x34Ba6e229A7C4449B3E0ee1fDb848697839386BC'
  // }
  // ,
  { // Arbitrum Sepolia Testnet
    chainId: 421614, 
    bridge: '0x9a9948BC249B834262A46aC6CE0C8446B2AB52b6'
  }
  ,
  // { // Optimism Goerli Testnet
  //   chainId: 420, 
  //   bridge: '0x34Ba6e229A7C4449B3E0ee1fDb848697839386BC'
  // }
  // ,
  { // Optimism Sepolia Testnet
    chainId: 11155420, 
    bridge: '0x49c31a704416c411081147C2EE115463e8Be80B0'
  }
  ,
  // { // Base Goerli Testnet
  //   chainId: 84531, 
  //   bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  // }
  // ,
  { // Base Sepolia Testnet
    chainId: 84532, 
    bridge: '0x9a9948BC249B834262A46aC6CE0C8446B2AB52b6'
  }
  ,
  { // Linea Testnet
    chainId: 59140, 
    bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  }
  ,
  { // Avalanche Fuji Testnet
    chainId: 43113, 
    bridge: '0x34Ba6e229A7C4449B3E0ee1fDb848697839386BC'
  }
  ,
  { // Fantom Testnet
    chainId: 4002, 
    bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  }
  ,
  { // Kub Testnet
    chainId: 25925, 
    bridge: '0x9ab2e175b6329c2bbd9ba7febf95b89a4f3a2988'
  }
  ,
  { // Flare Testnet Coston
    chainId: 16, 
    bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  }
  ,
  { // Sepolia PGN (Public Goods Network) Public Goods Network (PGN) - Testnet
    chainId: 58008, 
    bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  }
  ,
  ,
  { // Haqq Chain - Testnet
    chainId: 54211, 
    bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  }
  ,
  { // Lightlink - Testnet Pegasus
    chainId: 1891, 
    bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  }
  ,
  { // Taiko - Testnet Jolnir L2
    chainId: 167007, 
    bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  }
  ,
  { // Mode - Testnet
    chainId: 919, 
    bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  }
  ,
  { // Neo EVM - Testnet
    chainId: 2970385, 
    bridge: '0xB112A23C2E8881Fd2c494776872131b6b674e3ce'
  }
  ,
  { // ZetaChain - Testnet Athens 3
    chainId: 7001, 
    bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  }
  ,
  { // Scroll - Testnet Sepolia
    chainId: 534351, 
    bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  }
  ,
  { // Mantle - Testnet
    chainId: 5001, 
    bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  }
  ,
  { // opBNB - Testnet
    chainId: 5611, 
    bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  }
  ,
  { // Omni Network - Testnet
    chainId: 165, 
    bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  }
  ,
  { // Manta Pacific - Testnet
    chainId: 3441005, 
    bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  }
  ,
  { // Kroma - Testnet Sepolia
    chainId: 2358, 
    bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  }
  ,
  { // Polygon zkEVM - Testnet
    chainId: 1442, 
    bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  }
  ,
  { // Shardeum Sphinx 1.X - Testnet Dapp
    chainId: 8081, 
    bridge: '0xf074c4976042596b9d37165ed454147d38d4ba78'
  }
  ,
  { // X1 (OKX L2) - Testnet
    chainId: 195, 
    bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  }
  ,
  { // Arbitrum Stylus - Testnet
    chainId: 23011913, 
    bridge: '0x9Ab2e175b6329c2BBD9ba7Febf95B89A4f3a2988'
  }
  ,
  { // Frame - Testnet
    chainId: 68840142, 
    bridge: '0x4d2444bDf19a58F52484F91440fE8c7c83E5d240'
  }
  ,
  { // zKatana - Testnet
    chainId: 1261120, 
    bridge: '0x9a9948BC249B834262A46aC6CE0C8446B2AB52b6'
  }
  ,
  { // Redstone - Testnet
    chainId: 17001, 
    bridge: '0x1335e927f77030494B65B340dc734D86Df9E7b0e'
  }
  ,
  { // Gnosis - Testnet Chiado
    chainId: 10200, 
    bridge: '0x9a9948BC249B834262A46aC6CE0C8446B2AB52b6'
  }
  ,
  { // Zora Sepolia - Testnet
    chainId: 999999999, 
    bridge: '0x1335e927f77030494B65B340dc734D86Df9E7b0e'
  }
  ,
  { // Blast Sepolia - Testnet
    chainId: 168587773, 
    bridge: '0x9a9948BC249B834262A46aC6CE0C8446B2AB52b6'
  }
  ,
  { // Taiko Katla - Testnet
    chainId: 167008, 
    bridge: '0x9a9948BC249B834262A46aC6CE0C8446B2AB52b6'
  }
  ,
  { // Berachain Artio - Testnet
    chainId: 80085, 
    bridge: '0x9a9948BC249B834262A46aC6CE0C8446B2AB52b6'
  }
  ,
  { // Tabichain 1.0 - Testnet
    chainId: 9789, 
    bridge: '0x9a9948BC249B834262A46aC6CE0C8446B2AB52b6'
  }
  ,
  { // Taiko - Testnet Hekla L2
    chainId: 167009, 
    bridge: '0x9a9948BC249B834262A46aC6CE0C8446B2AB52b6'
  }
  ,
  { // ALIENX Hal Testnet
    chainId: 10241025, 
    bridge: '0x9a9948BC249B834262A46aC6CE0C8446B2AB52b6'
  }
  ,
  { // Sei Testnet
    chainId: 1328, 
    bridge: '0x1335e927f77030494B65B340dc734D86Df9E7b0e'
  }
  ,
  { // Soneium - Minato
    chainId: 1946, 
    bridge: '0x9D244f64B578d3a0786cef83072b046Fe460308d'
  }
  ,
  { // Story - Testnet
    chainId: 1513, 
    bridge: '0x1335e927f77030494B65B340dc734D86Df9E7b0e'
  }
  ,
  { // Hemi - Sepolia
    chainId: 743111, 
    bridge: '0x9a9948BC249B834262A46aC6CE0C8446B2AB52b6'
  }
  ,
  { // Kaia Kairos - Testnet
    chainId: 1001, 
    bridge: '0x9a9948bc249b834262a46ac6ce0c8446b2ab52b6'
  }
  ,
  { // Unichain Sepolia - Testnet
    chainId: 1301, 
    bridge: '0x9a9948bc249b834262a46ac6ce0c8446b2ab52b6'
  }
  ,
  { // Superposition - Testnet
    chainId: 98985, 
    bridge: '0x9a9948bc249b834262a46ac6ce0c8446b2ab52b6'
  }
  ,
  { // Ink - Sepolia
    chainId: 763373, 
    bridge: '0x1335e927f77030494B65B340dc734D86Df9E7b0e'
  }
  // ,
  // { // 	Mint Testnet
  //   chainId: 1686, 
  //   bridge: '0x9a9948BC249B834262A46aC6CE0C8446B2AB52b6'
  // }



  // ,
  // { // Orenium Testnet Protocol
  //   chainId: 8890, 
  //   bridge: '0xBE91ac5EAa8B00Fc62ADD0A9F798891A360C4424'
  // }



  // ,
  // { // Metis - Testnet Goerli
  //   chainId: 599, 
  //   bridge: '0x9a9948BC249B834262A46aC6CE0C8446B2AB52b6'
  // }
  // ,
  // { // Neon EVM - Testnet Devnet
  //   chainId: 245022926, 
  //   bridge: '0x1335e927f77030494b65b340dc734d86df9e7b0e'
  // }



  // ,
  // { // zkSync ERA - Testnet
  //   chainId: 280, 
  //   bridge: '0x54E9Aa7a1084F19f5fBb333B8a18D2840832cD77'
  // }

]

export function getChainContracts (chainId) {
  return contracts.filter(
    (chain) => chain.chainId === chainId
  )[0]
}
